import React from 'react';
import ModalWindow from '../Shared/ModalWindow';
import ComponentLoading from '../Shared/ComponentLoading';
import BasicPartInfo from './PartInformationModal/BasicPartInfo';
import InternalOnlyInfo from './PartInformationModal/InternalOnlyInfo';
import PartNumberChangeHistory from './PartInformationModal/PartNumberChangeHistory';
import PartPlanningInformation from './PartInformationModal/PartPlanningInformation';
import SuggestionOrderReturnHistory from './PartInformationModal/SuggestionOrderReturnHistory';
import SalesHistory from './PartInformationModal/SalesHistory';
import SessionManager from './SessionManager';
import './PartInformationModal/PartInformationModal.css';
import SuccessAlert from './SuccessAlert';
import OverridePartInfopopup from './PartInformationModal/OverridePartInfopopup';

export default class PartInformationModal extends React.Component {
    constructor(props) {
        super(props);

        this.sessionManager = new SessionManager();
        let pageText = this.sessionManager.GetSessionData("partInfoModalText");
        let userPermissions = this.sessionManager.GetSessionData("partInfoModalPermissions");

        if (!pageText) { this.getModalText(); }
        if (!userPermissions) { this.getModalPermissions(); }

        this.state = {
            pageText: pageText,
            userPermissions: userPermissions,
            partInfo: null,
            commentEdit: null,
            forceInLocator: null,
            overrideEdit: null,
            fullDemand: true,
            loading: true,
            dataError: false,
            alertMessage: "",
            callGetPartInfo: true,
            showOverridePartModal: false,
            overrideHeaderText: "Put part on override (comments)"
        };
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.inventorySkuPK !== this.props.inventorySkuPK ||
            prevProps.makeSkuPK !== this.props.makeSkuPK
        ) {
            this.setState({ loading: true, alertMessage: "" });
            this.getPartInfo();
        }
    }

    componentDidMount() {
        if (this.props.inventorySkuPK) {
            this.setState({ loading: true, alertMessage: "" })
            this.getPartInfo();
        }

    }

    getPartInfo() {
        $('#partInformationModal').modal('show');

        let url = 'api/PageContent/GetPartDetails/' + this.props.makeSkuPK + '/' + this.props.inventoryPK + '/' + this.props.inventorySkuPK;

        fetch(url)
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    partInfo: data,
                    commentEdit: null,
                    overrideEdit: null,
                    forceInLocator: data.partDetails.forceInLocator,
                    loading: false,
                    dataError: false,
                    callGetPartInfo: false
                });
            })
            .catch((error) => {
                this.setState({ dataError: true });
            });
    }

    getModalText() {
        fetch('api/PageContent/GetWidgetText/33')
            .then(response => response.json())
            .then(data => {
                this.sessionManager.SetSessionData("partInfoModalText", data);
                this.setState({
                    pageText: data
                });
            });
    }

    getModalPermissions() {
        fetch('/api/User/GetPermissionsByWidget/' + this.props.inventoryPK + '/33')
            .then(response => response.json())
            .then(data => {
                this.sessionManager.SetSessionData("partInfoModalPermissions", data);
                this.setState({
                    userPermissions: data
                });
            });
    }

    handleOnSaveClose() {

        let part = this.state.partInfo;
        let dbComment = part.partNote ? part.partNote.note : null;
        let dbOverride = part.inventorySkuClickToBuyOverride ? part.inventorySkuClickToBuyOverride.clickToBuyFK : null;
        let dbForceInLocator = part.partDetails.ForceInLocator;
        let newNote = null;
        let newOverride = null;
        let newForceInLocator = null;

        if (this.state.commentEdit !== dbComment) {
            newNote = {
                inventorySkuNotePK: part.partNote ? part.partNote.inventorySkuNotePK : null,
                note: this.state.commentEdit
            };

            part.partNote = newNote;
        }

        if (this.state.overrideEdit !== dbOverride) {
            newOverride = this.state.overrideEdit;
            if (part.inventorySkuClickToBuyOverride === null) {
                part.inventorySkuClickToBuyOverride = {
                    clickToBuyFK: null,
                    ExpirationDate: null
                };
            }

            part.inventorySkuClickToBuyOverride.clickToBuyFK = this.state.overrideEdit;
        }

        if(this.state.forceInLocator !== dbForceInLocator) {
            newForceInLocator = this.state.forceInLocator;
            part.partDetails.forceInLocator = newForceInLocator;
        }

        this.setState({
            partInfo: part
        });

        fetch('api/PageContent/SavePartInformation', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                InventoryPK: this.props.inventoryPK,
                InventorySkuPK: this.props.inventorySkuPK,
                PartNote: newNote,
                OverridePK: newOverride,
                ForceInLocator: newForceInLocator
            })
        })
            .catch((error) => {
                //todo: add text to db
                //todo: think about common text to load once per page (such as error message text etc.)
                console.log(error);
                alert('There was an error processing the Remove request. Please try again.\n\nIf the error persists, please contact our support department');
                location.reload();
            });
    }

    handleOnClose() {
        this.setState({
            commentEdit: null,
            overrideEdit: null,
            forceInLocator: this.state.partInfo?.partDetails?.forceInLocator
        });
        this.props.onClose && this.props.onClose();
    }

    handleOnChangePartNote(event) {
        this.setState({
            commentEdit: event.target.value
        });
    }

    handleOnChangeForceInLocator(event) {
        let forceInLocator = event.target.checked;
        let desiredOverride = this.state.partInfo.makeClickToBuyOverrideLevels.find((e) => e.sellingPercentage === 110);
        let newOverridePK = desiredOverride?.makeClickToBuyPK ?? null;
        let part = this.state.partInfo;
        let shouldOverridePK = part.inventorySkuClickToBuyOverride ? part.inventorySkuClickToBuyOverride.clickToBuyFK === 0 : true;
        let finalOverridePK = shouldOverridePK && forceInLocator ? newOverridePK : null;

        this.setState({ alertMessage: "" });
        fetch('api/PageContent/SavePartInformation', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                InventoryPK: this.props.inventoryPK,
                InventorySkuPK: this.props.inventorySkuPK,
                PartNote: this.state.partInfo.partNote ? this.state.partInfo.partNote.note : null,
                OverridePK: finalOverridePK,
                ForceInLocator: forceInLocator
            })
        })
            .then(response => {
                if (response.ok) {
                    this.setState({
                        partInfo: part,
                        alertMessage: "success",
                        forceInLocator: forceInLocator
                    });
                }
            });
        if (finalOverridePK) {
            part.inventorySkuClickToBuyOverride = {
                clickToBuyFK: finalOverridePK
            };
        }
        part.partDetails.forceInLocator = forceInLocator;
    }

    handleOnChangeOverride(event) {
        //This onChange event used to simply change the OverrideEdit Field
        //But it was requested that this edit be auto-saved, unlike the part note.  hence the double fetch call to SavePartInfo.
        this.setState({ alertMessage: "" });
        let part = this.state.partInfo;
        fetch('api/PageContent/SavePartInformation', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                InventoryPK: this.props.inventoryPK,
                InventorySkuPK: this.props.inventorySkuPK,
                PartNote: this.state.partInfo.partNote ? this.state.partInfo.partNote.note : null,
                OverridePK: parseInt(event.target.value)
            })
        })
            .then(response => {
                if (response.ok) {
                    this.setState({
                        partInfo: part,
                        alertMessage: "success"
                    });
                }
            })
        if (part.inventorySkuClickToBuyOverride === null) {
            part.inventorySkuClickToBuyOverride = {
                clickToBuyFK: parseInt(event.target.value)
            };
        } else {
            part.inventorySkuClickToBuyOverride.clickToBuyFK = parseInt(event.target.value);
        }
    }

    handleOnChangeDemandFilter(event) {
        let fullDemand = !this.state.fullDemand;

        this.setState({
            fullDemand: fullDemand
        });
    }
    updateAlertMessage = () => {
        this.setState({ alertMessage: "" });
    }

    oncallOverride() {
        this.setState({
            showOverridePartModal: true
        })
    }

    handleOnOverideClick(comment) {
        fetch('api/PageContent/AddManualOverride', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                InventoryPK: this.props.inventoryPK,
                InventorySkuPK: this.state.partInfo.partDetails.inventorySkuPK,
                Comment: comment
            })
        })
            .then(() => {
                this.getPartInfo(); // Directly refresh after override
                this.setState({ showOverridePartModal: false });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        let modalBody;
        let modalTitle;
        let part = this.state.partInfo;
        let cEdit = this.state.commentEdit;
        let forceInLocatorEdit = this.state.forceInLocator;
        let oEdit = parseInt(this.state.overrideEdit);
        let saveClose = false;

        if (this.state.dataError) {
            modalBody = this.props.displayError(() => this.getPartInfo());
        } else if (this.state.loading) {
            modalBody = <ComponentLoading />;
        } else {
            let pageText = this.state.pageText;
            modalTitle = pageText.partInfoTitle + part.partDetails.partNumber;
            if ((cEdit !== null && cEdit !== (part.partNote ? part.partNote.note : null)) ||
                (oEdit >= 0 && oEdit !== (part.inventorySkuClickToBuyOverride ? part.inventorySkuClickToBuyOverride.clickToBuyFK : null))) {
                saveClose = true;
            }

            modalBody = (
                <div className="partInfoModal">
                    <BasicPartInfo
                        partInfo={part.partDetails}
                        dealerCode={part.dealerCode}
                        ssChain={part.ssChain}
                        inventorySkuClickToBuyLevels={part.inventorySkuClickToBuyOverride}
                        makeClickToBuyOverrideLevels={part.makeClickToBuyOverrideLevels}
                        defaultClickToBuyLevel={part.defaultClickToBuyLevel}
                        partNote={part.partNote}
                        pageText={pageText}
                        commentEdit={cEdit}
                        forceInLocator={forceInLocatorEdit}
                        overrideEdit={oEdit}
                        dateFormatter={this.props.dateFormatter}
                        onChangePartNote={(e) => this.handleOnChangePartNote(e)}
                        onChangeForceInLocator={(e) => this.handleOnChangeForceInLocator(e)}
                        onChangeOverride={(e) => this.handleOnChangeOverride(e)}
                        clickToBuy={this.props.clickToBuy}
                        culture={this.props.culture}
                        userPermissions={this.state.userPermissions}
                        dateFormat={this.props.dateFormat}
                        onOverridePart={this.onOverridePart}
                        inventoryPK={this.props.inventoryPK}
                        getPartInfo={this.getPartInfo}
                        oncallOverride={this.oncallOverride.bind(this)}
                        sessionInfo={this.props.sessionInfo}
                    />
                    {this.state.alertMessage == "success" ? <div><SuccessAlert
                        message={this.state.pageText.partInfoClickToBuyText}
                        action={() => this.updateAlertMessage()} /></div> : null}
                    {
                        this.state.userPermissions && this.state.userPermissions.includes(1)?
                            <InternalOnlyInfo
                                partInfo={part.partDetails}
                                planningParameters={part.planningParameters}
                                planningDays={part.planningDays}
                                pageText={pageText}
                                dateFormatter={this.props.dateFormatter}
                            />
                            : null
                    }
                    <div className="row no-gutters">
                        <div className="col-sm-6 padding">
                            <PartPlanningInformation
                                partInfo={part.partDetails}
                                pageText={pageText}
                            />
                            <PartNumberChangeHistory
                                partInfo={part.ssChain}
                                pageText={pageText}
                                updateInfoSkuPK={this.props.updateInfoSkuPK}
                                OptUseAvailableToGenerateOrder={this.props.OptUseAvailableToGenerateOrder}
                                sessionInfo={this.props.sessionInfo}
                            />
                        </div>
                        <div className="col-sm-6 padding">
                            <SuggestionOrderReturnHistory
                                partInfo={part.orderDetails}
                                pageText={pageText}
                                dateFormatter={this.props.dateFormatter}
                                dateFormat={this.props.dateFormat}
                                dealerTimeZoneConvertor={this.props.dealerTimeZoneConvertor}
                            />
                        </div>
                    </div>
                    <SalesHistory
                        partInfo={this.state.fullDemand ? part.rolledMonthlyDemand : part.monthlyDemand}
                        pageText={pageText}
                        fullDemand={this.state.fullDemand}
                        onChangeFilter={(e) => this.handleOnChangeDemandFilter(e)}
                    />
                </div>
            );
        }

        return (
            <>
                <ModalWindow
                    modalId="partInformationModal"
                    modalTitle={modalTitle}
                    modalBody={modalBody}
                    modalSize="modal-lg"
                    saveClose={saveClose}
                    onModalClose={() => this.handleOnClose()}
                    onModalSaveClose={() => this.handleOnSaveClose()}
                />
                <OverridePartInfopopup
                    pageText={this.state.pageText}
                    onHide={() => this.setState({
                        showOverridePartModal: false
                    })}
                    show={this.state.showOverridePartModal}
                    handleOnOverideClick={this.handleOnOverideClick.bind(this)}
                />
            </>
        );
    }
}

